export { default } from './SliderPopularProducts'
